<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    type="list"
    :pagination="{
      count: tableData.count,
      current: +$route.query.p,
      request: 'users/',
    }"
    @tableData="tableData = $event"
    @loading="loading = $event"
  >
    <tableSearch
      @search="search = $event"
      :placeholder="
        $t('SEARCH_FOR', {
          type: $t('TITLE'),
        })
      "
    />

    <customDialog
      customWidth="60 %"
      v-if="isResetPassOpen"
      :title="$t('RESET_PASSWORD')"
      childClass="info_msg"
      :show="isResetPassOpen"
      @show="isResetPassOpen = $event"
      @confirmButn="handleResetPass"
      form="true"
    >
      <el-form
        
        :model="ruleForm"
        label-position="top"
        ref="ruleForm"
        :rules="rules"
        label-width="120px"
        class="demo-ruleForm grid grid-cols-2 gap-4"
      >
        
      <el-form-item :label="$t('PASSWORD')" prop="password1">
        <el-input
          type="password"
          v-model="ruleForm.password1"
          autocomplete="off"
          show-password
          class="left-inputs"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$t('CONFIRM_PASSWORD')" prop="password2">
        <el-input
          type="password"
          v-model="ruleForm.password2"
          autocomplete="off"
          show-password
          class="left-inputs"
        ></el-input>
      </el-form-item>

        <template v-slot:footerConfirm>
          <el-button type="success" @click="submitForm('ruleForm')">
            {{ $t('SUBMIT') }}
          </el-button>
        </template>
      </el-form>
    </customDialog>

    <el-table
      :empty-text="$t('NO_DATA')"
      :data="
        tableData.results.filter(
          (data) => !search || data.username.includes(search)
        )
      "
      v-loading="loading"
      :stripe="true"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('USERNAME')"
        width="160"
      >
        <template slot-scope="scope">
          <div :data-title="$t('USERNAME')" class="flex">
            {{ scope.row.username }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('date_joined')"
        width="180"
      >
        <template slot-scope="scope">
          <div :data-title="$t('date_joined')">
            {{ new Date(scope.row.date_joined).toLocaleDateString('fa-IR') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('STATUS')"
        width="160"
      >
        <template slot-scope="scope">
          <div :data-title="$t('STATUS')" class="flex">
            <span v-if="scope.row.is_active" class="text-green-700">
              {{ $t('ACTIVE') }}
            </span>

            <span v-else class="text-red-700">
              {{ $t('INACTIVE') }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="" width="170">
        <template slot-scope="scope">
          <div class="fixed-column">
            <tableFeatures
              :isDeleteable="false"
              :router="{
                name: 'EDIT_USER',
                id: scope.row.id,
              }"
              :title="$t('USER')"
              @view="view($event, 'VIEW_USER')"
              :view="true"
            >
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('RESET_PASSWORD')"
              placement="bottom"
            >
            <i class="el-icon-refresh-left text-xl cursor-pointer text-yellow-500" @click="isResetPassOpen = true; selectedId = scope.row.id"></i>
          </el-tooltip>
            </tableFeatures>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </Content>
</template>

<script>
import { usersList, resetPassUser } from '@/api/acl'
import tableSearch from '@/components/elements/tableSearch'
import tableFeatures from '@/components/elements/tableFeatures'
import { view } from '@/mixins/viewPage'
import { resetForm } from '@/mixins/resetForm'
import customDialog from '@/components/elements/dialog'

export default {
  mixins: [view, resetForm],
  data() {
    const passwordValidator = (rule, value, callback) => {
      if (!value) {
        callback(
          new Error(
            this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('PASSWORD'),
            })
          )
        )
      } else if (value.length < 8) {
        callback(new Error(this.$i18n.t('PASSWORD_TOO_SHORT')))
      } else if (/^\d+$/.test(value)) {
        callback(new Error(this.$i18n.t('PASSWORD_ENTIRELY_NUMERIC')))
      } else {
        callback()
      }
    }

    const confirmPasswordValidator = (rule, value, callback) => {
      if (value !== this.ruleForm.password1) {
        callback(new Error(this.$i18n.t('PASSWORDS_DO_NOT_MATCH')))
      } else {
        callback()
      }
    }

    return {
      tableData: {
        results: [],
      },
      loading: true,
      search: '',
      isResetPassOpen: false,
      selectedId: null,
      ruleForm: {
        password1: '',
        password2: '',
      },
      rules: {
        
        password1: [
          {
            required: true,
            validator: passwordValidator,
            trigger: 'blur',
          },
        ],
        password2: [
          {
            required: true,
            validator: confirmPasswordValidator,
            trigger: 'blur',
          },
        ],
      },
    }
  },

  methods: {
    handleResetPass() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          const actionPayload = {
            password1: this.ruleForm.password1,
            password2: this.ruleForm.password2,
            id: this.selectedId
          }

          resetPassUser.api(actionPayload).then((res) => {
            if (res) {
              this.isResetPassOpen = false
              this.selectedId = null
              this.resetForm('ruleForm')

              this.$notify.success({
                title:
                  this.$t('RESET_PASSWORD') +
                  ' ' +
                  this.$t('SUCCESSFULLY_DONE'),
                duration: 5000,
                customClass: 'succ_msg',
              })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t('RESET_PASSWORD'),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },
  mounted() {
    usersList.api().then((res) => {
      if (res) {
        this.tableData = res
      }
      this.loading = false
    })
  },
  components: {
    tableSearch,
    tableFeatures,
    customDialog
  },
}
</script>
